const openSimulatorEvent = new CustomEvent('openSimulator');
const closeSimulatorEvent = new CustomEvent('closeSimulator');

const openSimulator = (): void => {
  window.dispatchEvent(openSimulatorEvent);
};

const closeSimulator = (): void => {
  window.dispatchEvent(closeSimulatorEvent);
};

export { openSimulator, closeSimulator };
